
var serverActions = {
  getMyData: 'get_my_data',
  setMyData: 'set_my_data',
  changePassword: 'change_password'
};


class ProfileService {
    constructor($q, LoginService, ServerConnectorService) {
      this.$q = $q;
      this.loginService = LoginService;
      this.serverConnectorService = ServerConnectorService;
    }
    
    // TODO all emthods with webscotecs have common parts and should be merged
    getCurrentClientData(){
      console.log('getCurrentClientData');
      var deferred = this.$q.defer();
      var websocket = this.loginService.getCurrentUserWebsocket();

      var request = {
          action_name : serverActions.getMyData,
      };

      this.serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    updateProfile(profile) {
      var deferred = this.$q.defer();
      var websocket = this.loginService.getCurrentUserWebsocket();

      var request = {
        action_name : serverActions.setMyData,
        language : profile.language,
        first_name : profile.first_name,
        last_name : profile.last_name,
        phone : profile.phone
      };

      this.serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    changePassword(oldPassword, newPassword) {
      var deferred = this.$q.defer();
      var websocket = this.loginService.getCurrentUserWebsocket();

      var request = {
        action_name : serverActions.changePassword,
        old_password : oldPassword,
        new_password : newPassword
      };

      this.serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    static factory($q, LoginService, ServerConnectorService){
      return new ProfileService($q, LoginService, ServerConnectorService);
    }
}

ProfileService.factory.$inject = ['$q', 'LoginService', 'ServerConnectorService'];
export default ProfileService = ProfileService.factory;


// WEBPACK FOOTER //
// ./src/service/server-connector/profile.service.js